<template>
    <body class="white-bg">
        <div class="research">
            <div id="start" class="ibox page-full ">
                <div class="r-header">SK텔레콤 노동조합 {{}}</div>
                <div></div>
                <div class="r-box no-borders white-bg" style="padding: 10px;">
                    <div>
                        <div style="border: 5px double #337AB7; padding: 1px;">
                            <b>
                                <br><br>
                                <font size="6">{{ title }}</font>
                                <br>
                                <font size="4">{{ description }}</font>
                                <br>
                                <!-- <font size="5">전자 투표</font> -->
                            </b>
                            <br>
                            <div align="center" style="margin: 0px 0px 10px; padding: 1px; background-color: rgb(198, 217, 241);">
                                <b><font color="black" size="5">{{ pageTitle }}</font></b>
                                <br/>
                                <font color="black" size="3">{{ pageDescription }}</font>
                                <!-- <br/>
                                <b><font color="black" size="4">안건 투표</font></b> -->
                            </div>
                            <br/>
                        </div>
                        <br>
                    </div>
                    
                    <div class="r-font-size mb-4" style="margin-top: 10px;">
                        <br/><br/>
                        <button :disabled="!opened || closed" class="btn btn-success r-btn-width r-btn-blue" @click="next()">{{entranceText}}</button>
                    </div>
                </div>
            </div>
        </div>
    </body>
</template>

<script>

import AnswerService from '@/services/AnswerService'

export default {
  name: 'AnswerHome',
  props: {
    //msg: String
  },
  data() {
    return {
        pageHash: null,
        answerType: "//yong-todo",
        title: null,
        description: "SK텔레콤 노동조합",
        pageTitle: null,
        pageDescription: null,
        opened: false,
        closed: false,
        entranceText: null,
    }
  },
  mounted() {
      window.scrollTo(0, 0)
      this.pageHash = this.$route.params.pageHash

      AnswerService.intro(this.pageHash, (ok) => {
          this.opened = ok.data.opened
          this.closed = ok.data.closed

          this.entranceText = this.getEntranceText()

          this.title = ok.data.title
          if (ok.data.description) this.description = ok.data.description
          
          this.pageTitle = ok.data.pageTitle
          this.pageDescription = ok.data.pageDescription
      })
  },
  methods: {
      getEntranceText() {
          if (this.closed) return "본 설문은 마감되었습니다"
          if (!this.opened) return "설문이 오픈 전입니다"
          return "들어가기"
      },

      next() {
          this.$router.push({ name: "answer-auth", params: {pageHash: this.pageHash}})
      },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
